export default function Services() {
  const services = [
    {
      icon: "👕",
      title: "Custom T-Shirts",
      text: "DTF printed T-shirts for businesses, schools, events and everyday wear.",
    },
    {
      icon: "🧥",
      title: "Hoodies & Jackets",
      text: "Premium hoodies and jackets with vibrant long-lasting prints.",
    },
    {
      icon: "🏉",
      title: "Sportswear",
      text: "Team kits, supporter shirts, golf days and sports events.",
    },
    {
      icon: "🎁",
      title: "Corporate Branding",
      text: "Workwear, uniforms, promotional clothing and branded gifts.",
    },
    {
      icon: "🎨",
      title: "DTF Transfers",
      text: "High-quality DTF transfers ready to press onto garments.",
    },
    {
      icon: "🚚",
      title: "Nationwide Delivery",
      text: "Fast and reliable delivery anywhere in South Africa.",
    },
  ];

  return (
    <section
      id="services"
      className="bg-[#0b1220] py-24 text-white"
    >
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-5xl font-black text-center mb-4">
          OUR SERVICES
        </h2>

        <p className="text-center text-gray-400 mb-16">
          Everything you need for custom apparel and branding.
        </p>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">

          {services.map((service) => (

            <div
              key={service.title}
              className="rounded-3xl bg-slate-900 border border-sky-500/20 p-8 hover:border-sky-400 hover:-translate-y-2 transition duration-300 hover:shadow-2xl hover:shadow-sky-500/20"
            >

              <div className="text-6xl mb-6">
                {service.icon}
              </div>

              <h3 className="text-2xl font-bold mb-4">
                {service.title}
              </h3>

              <p className="text-gray-400">
                {service.text}
              </p>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}